




























import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue, IProject } from '@/lib/interfaces';
import { EIssueStatus } from '@/lib/enums';
import { getMyIssues } from '@/services/api.service';
import { mapState } from 'vuex';
import { pushOrDeleteIssue } from '@/lib/helpers/issue.helper';

@Component({
  sockets: {
    issueUpdated(this: DoneIssues, newIssue: IIssue) {
      pushOrDeleteIssue(this.issues, newIssue, newIssue.status === EIssueStatus.Done);
    },
  },
  computed: mapState(['hiddenProjectTabs']),
})
export default class DoneIssues extends Vue {
  public hiddenProjectTabs!: { string: boolean };

  private issues: IIssue[] = [];
  private groupByProject: boolean = false;

  private get groupedIssues(): Map<string, IIssue[]> {
    const map = new Map<string, IIssue[]>();
    this.issues.forEach((issue) => {
      const possibleIssues = map.get(issue.project._id!);
      if (!possibleIssues) {
        map.set(issue.project._id!, [issue]);
      } else {
        possibleIssues.push(issue);
      }
    });
    return map;
  }

  private get projects(): Map<string, string> {
    const map = new Map<string, string>();
    this.issues.forEach((issue) => {
      map.set(issue.project._id!, issue.project.title);
    });
    return map;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const issues: IIssue[] = await getMyIssues({ status: EIssueStatus.Done });
    next((vm: DoneIssues) => {
      vm.issues = issues;
    });
  }

  private onClickProjectToggleButton(projectId: string) {
    this.$store.commit('toggleProjectTab', projectId);
  }
}
